<template>
  <div class="grid grid-cols-12 gap-x-2">
    <div
      class="col-span-6"
      v-for="type in filteredTypes"
      :key="type.value"
    >
      <a
        href="#"
        class="flex flex-col items-center justify-center border rounded h-[90px]"
        :class="[
          modelValue === type.value
            ? 'bg-primary-50 border-primary-600'
            : 'text-gray-500 hover:bg-gray-100 hover:text-gray-700',
        ]"
        @click.prevent="method = type.value"
      >
        <span
          class="flex"
          :class="[modelValue === type.value ? '' : 'text-gray-500']"
        >
          <ion-icon
            name="card-outline"
            class="w-6 h-6"
            v-if="type.value === 'CARD'"
          />
          <ion-icon
            name="business-outline"
            class="w-6 h-6"
            v-if="type.value === 'ACH'"
          />
        </span>
        <span class="font-semibold text-xs md:text-base">{{ type.label }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "PortalPaymentMethodSelector",

  props: {
    // In: CARD or ACH
    modelValue: { required: true, type: String },
    cardFee: { required: false, type: Number, default: 0 },
    allowed: { required: true, type: Array, default: () => [] },
  },

  emits: ["update:modelValue"],

  data() {
    return {
      types: [
        { label: "Credit/Debit Card", value: "CARD", fee: this.cardFee },
        { label: "Bank Transfer (ACH)", value: "ACH", fee: null },
      ],
    }
  },

  computed: {
    method: {
      get() {
        return this.modelValue
      },

      set(value) {
        this.$emit("update:modelValue", value)
      },
    },

    filteredTypes() {
      if (!this.allowed) return []
      return this.types.filter((type) => this.allowed.includes(type.value))
    },
  },
}
</script>
